import { useTranslation } from 'react-i18next'

import { Badge } from '@percent/lemonade'

type RegistrationStatusBadgeProps = {
  registrationActive?: boolean | null
}

export function RegistrationStatusBadge({ registrationActive }: Readonly<RegistrationStatusBadgeProps>) {
  const { t } = useTranslation()

  if (typeof registrationActive !== 'boolean') {
    return null
  }

  return (
    <Badge variant={registrationActive ? 'positive' : 'critical'}>
      {t(registrationActive ? 'typography.active' : 'typography.inactive')}
    </Badge>
  )
}
